import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import windowDimension from "../../utils/windowDimension";
import { BriefType } from "../../constants/types";
import { withShowIf } from "../with-show-if/with-show-If.component";
import * as campaignBriefStore from "../../pages/campaign-brief/store/campaign-brief.store";

const NoBriefView = withShowIf(({ briefType }: { briefType: BriefType }) => {
  const canvasHeight = windowDimension().height;
  const canvasWidth = windowDimension().width;
  const outerIconSize = 150;
  const innerIconSize = 50;
  const textBoxWidth = 300;
  const textBoxHeight = 50;

  const briefTitle = (briefType: BriefType) => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
        return "Campaign Brief";
      case BriefType.EXECUTION_BRIEF:
        return "Execution Brief";
      case BriefType.WORK_ORDER:
        return "Brief Work Order";
    }
  };

  return (
    <>
      {briefType === BriefType.CAMPAIGN_BRIEF && (
        <>
          <Brightness1Icon
            color="disabled"
            style={{
              opacity: 0.3,
              fontSize: outerIconSize,
              position: "absolute",
              top: canvasHeight * 0.35,
              left: canvasWidth * 0.6 - outerIconSize * 0.5,
            }}
          />
          <FolderOpenIcon
            color="disabled"
            style={{
              opacity: 0.6,
              fontSize: innerIconSize,
              position: "absolute",
              top: canvasHeight * 0.35 + innerIconSize,
              left: canvasWidth * 0.6 - outerIconSize * 0.5 + innerIconSize,
            }}
          />
          <div
            style={{
              width: textBoxWidth,
              position: "absolute",
              top: canvasHeight * 0.35 + outerIconSize + 10,
              left: canvasWidth * 0.6 - textBoxWidth * 0.5,
            }}
          >
            <Typography variant={"h3"} style={{ color: "gray", textAlign: "center" }}>
              Let's Get Started
            </Typography>
            <Typography
              variant={"h6"}
              style={{ color: "gray", textAlign: "center", marginTop: "10px" }}
            >
              Create a New
              <Button
                color="primary"
                style={{ fontSize: 15, textDecoration: "underline" }}
                onClick={campaignBriefStore.openNewBriefModal}
              >
                {briefTitle(briefType)}
              </Button>
            </Typography>
          </div>
        </>
      )}
      {briefType !== BriefType.CAMPAIGN_BRIEF && (
        <div
          style={{
            width: textBoxWidth,
            height: textBoxHeight,
            position: "absolute",
            top: canvasHeight * 0.5 - textBoxHeight * 0.5,
            left: canvasWidth * 0.6 - textBoxWidth * 0.5,
          }}
        >
          <Typography variant={"h3"} style={{ color: "gray", textAlign: "center" }}>
            {`No ${briefTitle(briefType)}`}
          </Typography>
        </div>
      )}
    </>
  );
});

export default NoBriefView;
